@use "variables" as *;

.card {
  justify-content: flex-start !important;
  min-width: 164px;
  min-height: 230px;
  height: 100%;
  border-radius: 16px !important;
}

.image {
  width: 100%;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.mainStack {
  width: 100%;
  flex-grow: 1;
}

.name {
  padding: $spacing-s 0 $spacing-s $spacing-s;
  font-size: $fontSize-m;
  text-align: start;
}

.subtitle {
  padding: 0 $spacing-s $spacing-s $spacing-s;
  font-size: $fontSize-xs;
  font-weight: normal;
  text-align: start;
  white-space: pre-wrap;
}

.username {
  font-size: $fontSize-xs;
  font-weight: lighter;
  padding: $spacing-s $spacing-s $spacing-s $spacing-xs;
  word-wrap: anywhere;
}

.avatar {
  width: 22px !important;
  height: 22px !important;
  margin: $spacing-xs;
  border-width: 1px;
}

.amount {
  font-size: $fontSize-xs;
  flex-grow: 1;
  margin-left: $spacing-s;
  align-self: center;
}

.reservedBox {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  opacity: 0.4;
  z-index: 90;
  .reservedText {
    text-align: center;
    font-size: $fontSize-ml;
    font-weight: bold;
    text-transform: uppercase;
  }
}
